<template lang="html">
  <div id="user-profile" class="row page">
    <div v-if="loader" class="loader"></div>
    <div class="col-md-3"></div>
    <div class="col-md-9 text-left">
      <div class="col-lg-12">
        <div class="user-profile-container">
          <div class="user-profile-header">
            <h3>{{translation.profile.previewProfile}}</h3>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="user-image">
                <img v-if="this.previewImage" class="img-responsive img-circle" v-bind:src="this.previewImage" :alt="translation.profile.altImage+users.firstName">
                <img v-else class="img-responsive img-circle" src="../../assets/img/user-home-icon-default.svg" alt="Defaul image">
              </div>
            </div>
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-6">
                  <p class="user-header-text">{{translation.registration.firstName}}</p>
                  <p class="user-text"><span v-if="users.firstName">{{users.firstName}}</span></p>
                </div>
                <div class="col-md-6">
                  <p class="user-header-text">{{translation.registration.lastName}}</p>
                  <p class="user-text"><span v-if="users.lastName">{{users.lastName}}</span></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <p class="user-header-text">{{translation.registration.email}}</p>
                  <p class="user-text"><span v-if="users.email">{{users.email}}</span></p>
                </div>
                <div class="col-md-6">
                  <p class="user-header-text">{{translation.registration.phoneNumber}}</p>
                  <p class="user-text"><span v-if="users.phoneNumber && users.phoneNumber != 'null'">{{users.phoneNumber}}</span></p>
                </div>
              </div>
            </div>
          </div>
          <div class="row user-adress">
            <div class="col-md-4">
              <p class="user-header-text" v-if="users.country">{{translation.updateProfile.country}}</p>
              <p class="user-text" v-if="users.country && users.country != 'null'">{{users.country}}</p>
            </div>
            <div class="col-md-4">
              <p class="user-header-text" v-if="users.city">{{translation.updateProfile.city}}</p>
              <p class="user-text" v-if="users.city && users.city != 'null'">{{users.city}}</p>
            </div>
            <div class="col-md-4">
              <p class="user-header-text" v-if="users.country">{{translation.updateProfile.neighborhood}}</p>
              <p class="user-text" v-if="users.neighborhood && users.neighborhood != 'null'">{{users.neighborhood}}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
    <div class="edit-user-profile">
      <div class="middle-user-container">
        <router-link to="/update-user-profile">{{translation.profile.edit}}</router-link>
      </div>
      <div class="mobile-user-container">
        <router-link to="/update-user-profile"><img src="../../assets/img/icons/edit-mobile.svg" alt="edti mobile icon"></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '../../components/Footer.vue';
export default {
  data(){
    return {
      translation: null,
      previewImage:null,
      loader: false,
      errors: [],
      users: []
    }
  },
  components: {
    Footer
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.loader = true;
    window.pageHeader = this.translation.users.profile;
    var self = this;
    if (localStorage.getItem('userLoggedIn') != undefined) {
      if ( localStorage.getItem('userLoggedIn') == true
        || localStorage.getItem('userLoggedIn') == 'true') {
        axios.get('get-user-profile')
        .then(function(response){
          self.loader = false;
          self.users = response.data.result
          if (self.users.avatar) {
            self.previewImage = self.users.avatar;
          }
        })
        .catch(err => err)
      }
    }else {
      self.$router.push({ name: 'home', params: { lang: window.lang } })
    }
  },
  methods: {

  }

}
</script>
<style>
  #user-profile{

    background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
    background-repeat:no-repeat;
    max-width:inherit;
    max-height: 100%;

    background-position: center;
    background-size: cover;
    min-height: 100vh;
  }
  #user-profile .footer {
    color: #707070;
  }
  .user-profile-container{
    margin-top: 5em;
    background: #fff;
    -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    border-radius: .75em;
    margin-bottom: 12em;
  }
  .user-profile-container .user-profile-header{
    background: #EEEEEE;
    border-top-left-radius: .75em;
    border-top-right-radius: .75em;
  }
  .user-profile-container h3{
    border-bottom: 1px solid #707070;
    padding: 1em;
    color: #3057B0;
  }
  .user-profile-container .user-header-text{
    color: #707070;
    margin-top: 2em;
  }
  .user-profile-container .user-text{
    color: #000;
    font-size: 1.1em;
    font-weight: 600;

  }
  .user-profile-container .user-image img {
    width: 10em;
    height: 10em;
    display: inline-block;
    border: 2px solid #3057B0;
  }
  .user-profile-container .user-adress .user-header-text,
  .user-profile-container .user-adress .user-text{
    margin-left: 1em;
  }
  .user-profile-container .user-adress .user-text{
    padding-bottom: 2em;
  }
  #user-profile .middle-user-container{
    position: fixed;
    bottom: 50px;
    left: 0;
    right: 0;
    z-index: 1;
  }
  #user-profile .middle-user-container a{
    display: inline-block;
    background: #FE7154;
    padding: .5em;
    padding-left: 1em;
    padding-right: 1em;
    border-radius: 2em;
    color: #fff;
  }
  #user-profile .mobile-user-container{
    display: none;
  }
  @media (max-width: 1024px) {
    #user-profile .middle-user-container{
      display: none;
    }
    #user-profile .mobile-user-container{
      position: fixed;
      display: block;
      bottom: 9em;
      right: 0;
      z-index: 1;
    }
  }
  @media (max-width: 768px) {
    #user-profile .mobile-user-container{
      bottom: 7em;
    }
  }
</style>
